export const WIDE_TABLE_CONTAINER = 'w-fit min-w-full overflow-visible';

export const WIDE_PAGE = 'w-fit min-w-full';

export const PINNED_BLOCK = 'sticky left-6 w-[calc(var(--main-width)-3rem)] empty:hidden';

export const COLUMN_MIN_WIDTH = {
  long: 'min-w-50',
  medium: 'min-w-48',
  short: 'min-w-40',
} as const;

export const STICKY_END_HEADER = 'right-0 z-20! shadow-[inset_1px_0_0_var(--color-border)]';
export const STICKY_END_CELL =
  'sticky right-0 bg-surface shadow-[inset_1px_0_0_var(--color-border)]';

export const STICKY_END_HEADER_PLAIN = 'right-0 z-20!';
export const STICKY_END_CELL_PLAIN = 'sticky right-0 bg-surface';
export const STICKY_START_HEADER_PLAIN = 'left-0 z-20!';
export const STICKY_START_CELL_PLAIN = 'sticky left-0 bg-surface';
